import PageReparadoras from '../../Components/Reparadoras-page/reparadoras'; 
import Agendamento from '../../Components/Banner-Agendamentos/BanAgendamentos';
import Footer from '../../Components/Footer/Footer';

function Reparadoras() {
    return (
      <>
        <div id="Reparadoras">
          <PageReparadoras /> 
        </div>
        <div id="banner-agendamento">
          <Agendamento />
        </div>
        <div id="footer">
          <Footer />
        </div>
      </>
    );
};

export default Reparadoras;
